import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: { main: '#447b32', dark: '#315e24', contrastText: '#ffffff' },
    secondary: { main: '#a64e32' },
    background: { default: '#f5f8e9', paper: '#ffffff' },
    text: { primary: '#26382d', secondary: '#657369' },
    divider: '#e1e6de',
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h5: { fontWeight: 700, letterSpacing: '-0.6px' },
    h6: { fontWeight: 700, letterSpacing: '-0.4px' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  // Preserve the editor's v4 field and breakpoint layout during the MUI migration.
  breakpoints: { values: { xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920 } },
  components: {
    MuiTooltip: { defaultProps: { disableInteractive: true } },
    MuiTextField: { defaultProps: { variant: 'standard' } },
    MuiSelect: { defaultProps: { variant: 'standard' } },
    MuiButton: { styleOverrides: { root: { padding: '10px 18px' }, contained: { boxShadow: 'none' } } },
    MuiIconButton: { styleOverrides: { root: { color: '#657369' } } },
    MuiBottomNavigationAction: {
      styleOverrides: {
        root: { minWidth: 64, minHeight: 64, padding: '10px 4px', borderRadius: 12, flexShrink: 0 },
        label: {
          fontSize: '0.7rem',
          marginTop: 5,
          '&.Mui-selected': { fontSize: '0.7rem', fontWeight: 700 },
        },
      },
    },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 18 } } },
  },
});

export default theme;
